import React, { useState } from 'react';
import '../../talukas/css/talukaManagement.css';
import TendersTable from './TendersTable';
import TenderFormModal from './TenderFormModal';
import TenderFilesModal from './TenderFilesModal';
import { FaPlus } from 'react-icons/fa';
import { tenderAPI } from '../../../utils/api';

export default function TendersManagement() {
  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [fileTender,setFileTender]=useState(null);
  const [reloadKey, setReloadKey] = useState(0);

  const save = async data => {
    const payload = { ...data };
    if (editRow?.id) await tenderAPI.update(editRow.id, payload);
    else await tenderAPI.create(payload);
    setShowModal(false); setEditRow(null); setReloadKey(k => k + 1);
  };

  return (
    <div className="eduss-taluka-management">
      <div className="eduss-page-header">
        <div><h2>Tenders</h2><p>Manage procurement tenders</p></div>
        <div className="eduss-dashboard-banner-date">{new Date().toLocaleDateString()}</div>
      </div>
      <div className="eduss-taluka-management-content-header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 12 }}>
        <button className="eduss-global-table-btn add" onClick={() => { setEditRow(null); setShowModal(true); }}><FaPlus /> Add Tender</button>
      </div>
      <div className="eduss-taluka-management-content">
        <TendersTable key={reloadKey} onEdit={r => { setEditRow(r); setShowModal(true); }} onFiles={t=>setFileTender(t)} />
      </div>
      <TenderFormModal open={showModal} initial={editRow} onClose={() => setShowModal(false)} onSave={save} />
      {fileTender && <TenderFilesModal tender={fileTender} onClose={()=>setFileTender(null)}/>}
    </div>
  );
}
